define('core/collections/VotersUserCollection',[
    'underscore',
    'backbone',

    'core/api',
    'core/collections/UserCollection',
], function (
    _,
    Backbone,

    api,
    UserCollection
) {
    'use strict';

    var VotersUserCollection = UserCollection.extend({
        LIMIT: 50,

        // NOTE: Intentionally using a function here because `api`
        //       has its base URL configured at run-time, and may not
        //       be configured by the time VotersUserCollection
        //       is declared.

        url: function () {
            return api.getURL('posts/listUsersVotedPost');
        },

        initialize: function (_models, options) {
            this.postId = options.postId;
            this.threadId = options.threadId;
        },

        fetch: function (options) {
            return Backbone.Collection.prototype.fetch.call(this, _.extend({
                data: {
                    post: this.postId,
                    thread: this.threadId,
                    vote: options.vote,
                    limit: this.LIMIT,
                },
            }, options));
        },
    });

    return VotersUserCollection;
});

